<div class="nearshoring-page">
  <!-- Intro Section -->
  <section class="intro">
    <div class="wrapper">
      <div class="pager">
        <div class="pager__line"></div>
        <div class="pager__dots">
          <div class="pager__dot"></div>
          <div class="pager__dot"></div>
          <div class="pager__dot"></div>
        </div>
      </div>
      <h1 class="intro__title">Nearshoring with Coara</h1>
      <p class="intro__text">
        Your European development team.<br />
        Quality without compromise.<br />
        A risk-free path to your own<br />
        development center.
      </p>
      <a [routerLink]="PATHS[ROUTES.NEARSHORING_EN]" fragment="contact" class="intro__button button">
        <span>Contact us</span>
        <i-feather name="arrow-right"></i-feather>
      </a>
    </div>
  </section>

  <!-- Main Banner -->
  <section class="main-banner">
    <div class="main-banner__wrapper">
      <h2 class="main-banner__title">Coara - Company Profile</h2>
      <p class="main-banner__text">
        We are your expert partner for SaaS product development, platform operation and building European development teams. We help make
        your business profitable.
      </p>
      <div class="main-banner__footer">
        <div class="main-banner__footer__text">Quality. Efficiency. European Standards.</div>
      </div>
    </div>
  </section>

  <div class="wrapper">
    <section class="nearshoring-page__section section">
      <h2 class="nearshoring-page__section__title section__title">About Us</h2>
      <p class="section__text">
        Coara is your expert partner for SaaS product development and platform operation. We are experienced serial founders who complete
        your team & make your business profitable. Going beyond software development, Coara is ideation, design, UX and product creation. We
        are an incubator for your new ideas, an accelerator to your business, and a profitability driver for your CFO. We develop digital
        products with outstanding UX and design.
      </p>
    </section>

    <section class="nearshoring-page__section section">
      <h2 class="nearshoring-page__section__title section__title">Main Expertise</h2>
      <ul class="section__list">
        <li class="section__list__item"><strong>Large Scale SaaS Platforms</strong></li>
        <li class="section__list__item"><strong>Building Software Development Nearshoring Teams</strong></li>
        <li class="section__list__item"><strong>Devops, Provider agnostic cloud infrastructure</strong></li>
        <li class="section__list__item"><strong>AI-Enhanced Development & Solutions</strong></li>
      </ul>
    </section>

    <section class="nearshoring-page__section section">
      <h2 class="nearshoring-page__section__title section__title">Company Overview</h2>
      <ul class="section__list">
        <li class="section__list__item"><strong>Founded:</strong> 2018</li>
        <li class="section__list__item"><strong>CEO & Founder:</strong> Christian Bolz</li>
        <li class="section__list__item"><strong>Offices:</strong> Estonia and Spain</li>
        <li class="section__list__item"><strong>Company Size:</strong> 11-50 employees</li>
      </ul>
    </section>

    <section class="nearshoring-page__section section">
      <h2 class="nearshoring-page__section__title section__title">Our Expertise</h2>
      <p class="section__text">
        We are truly passionate about innovation and disruption and we want to make your ideas become real. Our specialties include:
      </p>
      <ul class="section__list">
        <li class="section__list__item"><strong>SaaS, Data, AI</strong></li>
        <li class="section__list__item">User Experience (UX) Design</li>
        <li class="section__list__item">Ensurance of high coding quality and standards</li>
        <li class="section__list__item">AI Agents and Integration</li>
        <li class="section__list__item">AI Powered Development</li>
        <li class="section__list__item">Micro Service Architecture</li>
        <li class="section__list__item">Backend systems with NodeJS / NestJS, Kafka, Mongo, Postgres</li>
        <li class="section__list__item">Web Development (Angular / React / Vue)</li>
        <li class="section__list__item">Mobile App Development</li>
        <li class="section__list__item">Monitoring (Kibana, Grafana)</li>
        <li class="section__list__item">REST APIs, Integration with other systems</li>
        <li class="section__list__item">Customer Relationship Management, Loyalty</li>
        <li class="section__list__item">Shopify Solutions and Ecommerce Integrations</li>
        <li class="section__list__item">Wallet Passes</li>
        <li class="section__list__item">Internet of Things (IoT)</li>
      </ul>
    </section>

    <section class="nearshoring-page__section section">
      <h2 class="nearshoring-page__section__title section__title">Our Approach</h2>
      <p class="section__text">
        As an experienced team of serial founders, we understand the challenges of bringing new ideas to life and building a profitable
        company. We provide comprehensive support throughout the entire product development lifecycle:
      </p>
      <ul class="section__list">
        <li class="section__list__item">
          <strong>Ideation & Strategy:</strong> We help refine your concept and develop a clear product strategy.
        </li>
        <li class="section__list__item">
          <strong>Design & UX:</strong> We create intuitive, user-friendly designs that deliver outstanding experiences.
        </li>
        <li class="section__list__item"><strong>Development:</strong> Our technical expertise ensures robust, scalable solutions.</li>
        <li class="section__list__item"><strong>Growth & Scaling:</strong> We help you accelerate your business and gain traction.</li>
      </ul>
    </section>

    <section class="nearshoring-page__section section">
      <h2 class="nearshoring-page__section__title section__title">AI-Enhanced Development</h2>
      <p class="section__text">
        Our development team strategically leverages AI tools to enhance productivity and code quality while maintaining the highest
        standards for security and expertise:
      </p>
      <ul class="section__list">
        <li class="section__list__item">
          <strong>AI-Powered Development:</strong> We utilize advanced tools like Cursor (with Claude models) and Co-Pilot in our
          development workflow, carefully managing code repository access and privacy.
        </li>
        <li class="section__list__item">
          <strong>Strategic AI Implementation:</strong> While we harness AI for support, prototyping, and solving specific coding
          challenges, we deliberately avoid complete service automation, ensuring human expertise guides all development.
        </li>
        <li class="section__list__item">
          <strong>Rapid Prototyping:</strong> For MVPs and prototypes, we effectively combine AI-assisted code generation and design tools
          with our programming expertise to accelerate development while maintaining quality.
        </li>
        <li class="section__list__item">
          <strong>Client-Facing AI Solutions:</strong> We implement AI functionality (such as Insight AI) directly into client products,
          enabling our customers to benefit from sophisticated AI capabilities.
        </li>
      </ul>
      <p class="section__text">
        Our success in AI integration comes from our approach of combining our team's deep technical knowledge, adherence to code standards,
        thorough code reviews, and strategic AI utilization. This enables us to deliver superior results more efficiently while maintaining
        the human expertise that technology alone cannot provide.
      </p>
    </section>

    <section class="nearshoring-page__section section">
      <h2 class="nearshoring-page__section__title section__title">Nearshoring Excellence: Your European Development Team</h2>
      <p class="section__text">
        We specialize in building high-performing nearshore development teams that combine European talent quality with cost efficiency. Our
        approach delivers more than just developers — we create fully integrated teams aligned with your business goals and technical
        requirements.
      </p>

      <h3 class="nearshoring-page__section__subtitle section__list-title">Why Choose Nearshoring with Coara?</h3>
      <div class="nearshoring-page__benefits">
        <div class="nearshoring-page__benefits__item">
          <h4>Quality without Compromise</h4>
          <p class="section__text">
            We maintain rigorous quality standards through standardized development practices, comprehensive code reviews, and continuous
            testing protocols.
          </p>
        </div>
        <div class="nearshoring-page__benefits__item">
          <h4>Cultural & Time Zone Alignment</h4>
          <p class="section__text">
            Our European teams work in compatible time zones with your headquarters, sharing cultural understanding and business
            expectations.
          </p>
        </div>
        <div class="nearshoring-page__benefits__item">
          <h4>Cost Efficiency</h4>
          <p class="section__text">
            Leverage high-quality European talent at 30-40% lower costs compared to hiring equivalent teams in Western Europe.
          </p>
        </div>
        <div class="nearshoring-page__benefits__item">
          <h4>Scalability & Flexibility</h4>
          <p class="section__text">
            Rapidly scale your development capabilities up or down based on project demands without the administrative burden of direct
            hiring.
          </p>
        </div>
        <div class="nearshoring-page__benefits__item">
          <h4>Comprehensive Management</h4>
          <p class="section__text">
            We handle all aspects of team management, from hiring and training to performance monitoring and continuous improvement,
            allowing you to focus on your core business objectives.
          </p>
        </div>
      </div>

      <h3 class="nearshoring-page__section__subtitle section__list-title">Our Nearshoring Process</h3>
      <ul class="section__list">
        <li class="section__list__item">
          <strong>Requirements Analysis:</strong> We work with you to understand your technical needs, cultural requirements, and business
          objectives.
        </li>
        <li class="section__list__item">
          <strong>Team Design:</strong> We create a team structure tailored to your specific needs, including roles, seniority levels, and
          specialized skill sets.
        </li>
        <li class="section__list__item">
          <strong>Talent Selection:</strong> Our rigorous selection process ensures each team member meets both technical qualifications and
          cultural fit.
        </li>
        <li class="section__list__item">
          <strong>Integration & Alignment:</strong> We establish communication protocols, development standards, and reporting systems
          aligned with your processes.
        </li>
        <li class="section__list__item">
          <strong>Continuous Improvement:</strong> Regular performance reviews and optimization ensure ongoing enhancement of productivity
          and quality.
        </li>
      </ul>
    </section>

    <section class="nearshoring-page__section section">
      <h2 class="nearshoring-page__section__title section__title">Build-Operate-Transfer: The Ultimate Ownership Model</h2>
      <p class="section__text">
        For companies seeking long-term ownership of their nearshore team, we offer our innovative
        <strong>Build-Operate-Transfer (BOT)</strong> model — a risk-free path to establishing your own European development center.
      </p>

      <p class="section__text">
        <strong>Build-Operate-Transfer (BOT): Your Path to Full Team Ownership</strong><br />
        <em>Seamlessly transition from zero to full ownership of a skilled, operational tech team in Europe — with no upfront risk.</em>
      </p>

      <h3 class="nearshoring-page__section__subtitle section__list-title">Why Choose the BOT Model?</h3>
      <div class="nearshoring-page__benefits">
        <div class="nearshoring-page__benefits__item">
          <h4>No Upfront Risk</h4>
          <p class="section__text">
            We take care of the setup, legal hurdles, and hiring risks. You only commit financially once the team is proven and ready to
            deliver.
          </p>
        </div>
        <div class="nearshoring-page__benefits__item">
          <h4>Cost Efficiency</h4>
          <p class="section__text">
            Replace unpredictable operational costs (OPEX) with a one-time capital investment (CAPEX) after the transfer.
          </p>
        </div>
        <div class="nearshoring-page__benefits__item">
          <h4>Tax-Optimized / Balance sheet optimized</h4>
          <p class="section__text">
            The final transfer is structured as a share sale, optimizing balance sheet and maximizing savings for you and us.
          </p>
        </div>
        <div class="nearshoring-page__benefits__item">
          <h4>Speed to Market</h4>
          <p class="section__text">
            Leverage our pre-vetted talent pools e.g. in <strong>Estonia</strong> or <strong>Spain</strong> to deploy teams in
            <strong>weeks</strong>, not months.
          </p>
        </div>
        <div class="nearshoring-page__benefits__item">
          <h4>Seamless Transition</h4>
          <p class="section__text">We handle training, cultural alignment, and processes upfront—you inherit a turnkey operation.</p>
        </div>
      </div>

      <!--
      <h3 class="nearshoring-page__section__subtitle">Phases & Timeline</h3>
      <table class="nearshoring-page__table">
        <thead>
          <tr>
            <th>Phase</th>
            <th>Timeline</th>
            <th>Key Activities</th>
            <th>Client Benefits</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Build</strong></td>
            <td>1–3 Months</td>
            <td>
              - Talent sourcing & hiring <br />
              - Team training & onboarding <br />
              - Process/KPI alignment
            </td>
            <td>Zero operational burden; expert-led setup</td>
          </tr>
          <tr>
            <td><strong>Operate</strong></td>
            <td>3–12 Months</td>
            <td>
              - Daily team management <br />
              - Agile delivery & reporting <br />
              - Continuous improvement
            </td>
            <td>Flexible scaling; pay only for productive output</td>
          </tr>
          <tr>
            <td><strong>Transfer</strong></td>
            <td>1 Month</td>
            <td>
              - Legal/financial handover <br />
              - Knowledge transfer <br />
              - Post-transfer support
            </td>
            <td>Full ownership with no hidden surprises</td>
          </tr>
        </tbody>
      </table>

      <h3 class="nearshoring-page__section__subtitle">Pricing Model</h3>
      <table class="nearshoring-page__table">
        <thead>
          <tr>
            <th>Phase</th>
            <th>Pricing Structure</th>
            <th>Client Advantage</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Build</strong></td>
            <td>Fixed fee (covers hiring, training, setup)</td>
            <td>Predictable upfront cost</td>
          </tr>
          <tr>
            <td><strong>Operate</strong></td>
            <td>Daily/monthly rate per team member</td>
            <td>Aligns costs with productivity</td>
          </tr>
          <tr>
            <td><strong>Transfer</strong></td>
            <td>One-time CAPEX (share purchase)</td>
            <td>Long-term cost reduction vs. traditional outsourcing</td>
          </tr>
        </tbody>
      </table>
--->
      <h3 class="nearshoring-page__section__subtitle">Competitive Advantages</h3>
      <div class="nearshoring-page__competitive-advantages">
        <div class="nearshoring-page__competitive-advantages__item">
          <h4>Speed</h4>
          <p class="section__text">
            Deploy MVP-ready teams in <strong>30 days</strong> via our pre-vetted talent networks in Estonia or Spain.
          </p>
        </div>
        <div class="nearshoring-page__competitive-advantages__item">
          <h4>Local Expertise, Global Standards</h4>
          <p class="section__text">
            Deep knowledge of Eastern European tech talent pools (ranked among the top in developer skills in the EU), additionally our
            Southern European talent pool delivers excellent UX/UI and product skills. We follow security standards and ISO processes.
          </p>
        </div>
        <div class="nearshoring-page__competitive-advantages__item">
          <h4>Transparency</h4>
          <p class="section__text">Real-time performance dashboards during the Operate phase ensure accountability.</p>
        </div>
        <div class="nearshoring-page__competitive-advantages__item">
          <h4>Post-Transfer Success</h4>
          <p class="section__text">
            90 days of included support post-sale to guarantee continuity (e.g., HR, compliance, leadership coaching).
          </p>
        </div>
      </div>

      <p class="section__text">
        <strong>Turn Vision into Reality</strong><br />
        <em>Let us build your team today—so you can own it tomorrow.</em>
      </p>

      <blockquote>
        "Your team, our blueprint, zero risk."
      </blockquote>
    </section>

    <section class="nearshoring-page__section section">
      <h2 class="nearshoring-page__section__title section__title">Estonia: The Perfect Hub for Your Development Team</h2>
      <p class="section__text">
        Estonia has emerged as one of Europe's most attractive locations for technology companies and development teams. As our primary
        nearshoring hub, Estonia offers unique advantages that directly benefit our clients:
      </p>

      <h3 class="nearshoring-page__section__subtitle section__list-title">Digital-First Nation</h3>
      <ul class="section__list">
        <li class="section__list__item">
          <strong>World's Most Advanced Digital Society</strong><br />
          Estonia's e-government infrastructure allows 99% of public services to be performed online. Business registration takes just 18
          minutes, and tax filings can be completed in 3 minutes.
        </li>
        <li class="section__list__item">
          <strong>E-Residency Program</strong><br />
          Estonia's pioneering e-Residency program allows non-Estonian citizens to access Estonian services and establish a company fully
          remotely—ideal for international businesses setting up EU operations.
        </li>
        <li class="section__list__item">
          <strong>Paperless Administration</strong><br />
          Digital signatures have been legally binding since 2000, enabling contracts and official documents to be signed securely online
          without physical paperwork.
        </li>
      </ul>

      <h3 class="nearshoring-page__section__subtitle section__list-title">Business-Friendly Environment</h3>
      <ul class="section__list">
        <li class="section__list__item">
          <strong>Transparent Tax System</strong><br />
          Estonia's unique tax system only taxes distributed profits (not retained earnings), meaning companies can reinvest profits without
          tax burden—maximizing growth potential.
        </li>
        <li class="section__list__item">
          <strong>International Rankings</strong>
          <ul class="section__list">
            <li class="section__list__item">#1 in Tax Competitiveness (Tax Foundation)</li>
            <li class="section__list__item">Top 20 in Ease of Doing Business (World Bank)</li>
            <li class="section__list__item">#1 in Internet Freedom (Freedom House)</li>
          </ul>
        </li>
        <li class="section__list__item">
          <strong>Lowest Corruption in Eastern Europe</strong><br />
          Ranked among the least corrupt nations globally (Transparency International), providing predictability and reliability for
          business operations.
        </li>
      </ul>

      <h3 class="nearshoring-page__section__subtitle section__list-title">Technical Excellence</h3>
      <ul class="section__list">
        <li class="section__list__item">
          <strong>High-Quality Tech Education</strong><br />
          Estonia boasts a strong STEM education system and ranks among the top performers in the EU for digital skills.
        </li>
        <li class="section__list__item">
          <strong>Innovation Culture</strong><br />
          Birthplace of Skype, Wise (TransferWise), and Bolt, Estonia has the highest number of unicorn companies per capita in Europe.
        </li>
        <li class="section__list__item">
          <strong>EU Membership Benefits</strong><br />
          Full EU membership provides access to the European market, strong IP protection, and compliance with EU regulations—eliminating
          cross-border complexity.
        </li>
      </ul>

      <p class="section__text">
        <strong
          >We constantly monitor all European countries for the best locations of our Teams, but Estonia regularly ranks under the best for
          most cases.</strong
        >
      </p>
    </section>

    <section class="nearshoring-page__section section">
      <h2 class="nearshoring-page__section__title section__title">Selection of Client Success Stories</h2>
      <div class="nearshoring-page__references">
        <div class="nearshoring-page__references__item">
          <h3>Convercus Loyalty Platform</h3>
          <p class="section__text">
            Development and operation of the Convercus Loyalty Platform, the number 1 loyalty solution in the DACH market. This project
            showcases our ability to build and maintain large-scale SaaS platforms with enterprise-grade performance and reliability. Since
            March 2020 we are solely responsible for the Convercus platform development and operation as well as the implementation
            customized projects for their customers.
            <strong
              >Shortly after taking over this role, Convercus was able to become profitable and has grown revenue and profitability ever
              since.</strong
            >
          </p>
        </div>

        <div class="nearshoring-page__references__item">
          <h3>JeriCommerce</h3>
          <p class="section__text">
            Successfully developed and launched JeriCommerce on the Shopify App Store, providing innovative wallet pass solutions for
            e-commerce and retail businesses as a component of modern loyalty programs. This product demonstrates our expertise in creating
            seamless omni-channel customer engagement tools that complement retention and loyalty. JeriCommerce stands out for its quick
            installation process and easy integration, enabling merchants to leverage wallet pass technology without extensive technical
            knowledge. <strong>Co-Founder buy out in 2025.</strong>
          </p>
        </div>

        <div class="nearshoring-page__references__item">
          <h3>Drop</h3>
          <p class="section__text">
            Developed the technology platform for Yachtdrop & Villadrop, the invisible layer of hospitality. Drop is a startup specializing
            in ultra-fast delivery services for the luxury travel segment. The solution enables yacht owners, guests, and crew to receive
            premium products and services with exceptional speed and reliability. This project demonstrates our ability to create
            logistics-optimized digital platforms that cater to the unique needs of high-net-worth clients in exclusive markets. By
            combining sophisticated inventory management, real-time tracking, and a premium user experience, Yachtdrop has established
            itself as an innovative service provider in the luxury marine sector. After having entered as the responsable tech team and
            having taken over a strategic CTO position, <strong>Drop quickly doubled its value and is now valued at €5M.</strong>
          </p>
        </div>

        <div class="nearshoring-page__references__item">
          <h3>Plan M8 ("Plan Mate")</h3>
          <p class="section__text">
            Product Design and development of a sophisticated SaaS application for planned and unplanned maintenance on yachts. With our
            support the project secured initially a €150,000 pre-seed funding and was accepted into the Yachting Ventures Accelerator
            program. The app features offline operation capability (essential for offshore use), modern API architecture, and customizable
            maintenance templates. Plan M8 addresses a critical gap in the marine maintenance sector, providing yacht owners, operators,
            captains, and engineers with an efficient solution to manage maintenance tasks and reduce operating costs. Plan M8 operates
            today on a fleet of Yachts and Super Yachts of up to 50m.
            <strong>On the biggest yachts in Plan M8 orchestrates annual maintenance budgets of several millions of Euros.</strong>
          </p>
        </div>

        <div class="nearshoring-page__references__item">
          <h3>RiscBal</h3>
          <p class="section__text">
            Developed an advanced visualization system for natural disaster warnings. This solution was created in collaboration with a spin
            out of the University of Balearic Islands. It demonstrates our expertise in creating complex data visualization tools that help
            communicate critical information for emergency services effectively, securely and in a timely manner. The system helps users
            understand and respond to potential natural disasters, showcasing our capability to develop solutions that address significant
            societal challenges.
          </p>
        </div>

        <div class="nearshoring-page__references__item">
          <h3>Radcliffe Research Platform</h3>
          <p class="section__text">
            Developed a specialized medical research platform for Radcliffe Group in collaboration with the International Society of
            Cardiovascular Pharmacotherapy (ISCP). The platform enables the creation of a Clinical Consensus Document on Antiplatelet
            Therapy in Acute Coronary Syndrome through expert crowdsourcing. The system allows cardiovascular specialists to review medical
            literature, participate in structured surveys, and contribute to evidence-based consensus formation. The platform includes
            sophisticated document management, expert identification, and statistical analysis components that transform individual expert
            input into actionable consensus data. This project showcases our expertise in developing specialized research tools for the
            healthcare sector that facilitate global collaboration among medical professionals and contribute to peer-reviewed scientific
            publications.
          </p>
        </div>

        <div class="nearshoring-page__references__item">
          <h3>Baroon</h3>
          <p class="section__text">
            Developed a digital solution for efficient property management that revolutionizes how property owners and management companies
            communicate. Baroon simplifies information exchange through a modern, user-friendly mobile application that makes property
            management more efficient, location-independent, and timely. The platform helps property managers reduce time spent on
            administrative tasks so they can focus on customer service. As an evolving platform, Baroon continuously adapts to meet the
            needs of property owners and managers, demonstrating our ability to develop innovative solutions for traditional industries
            undergoing digital transformation.
          </p>
        </div>
      </div>
    </section>

    <section id="contact" class="nearshoring-page__contact section">
      <h2 class="nearshoring-page__contact__title section__title">Contact Information</h2>
      <ul class="section__list">
        <li class="section__list__item"><strong>CEO & Founder:</strong> Christian Bolz</li>
        <li class="section__list__item"><strong>Phone:</strong> +34 605 140 269</li>
        <li class="section__list__item"><strong>Email:</strong> <a href="mailto:chris@coara.co">chris@coara.co</a></li>
        <li class="section__list__item"><strong>Website:</strong> <a href="https://coara.co" target="_blank">https://coara.co</a></li>
        <li class="section__list__item">
          <strong>LinkedIn:</strong>
          <a href="https://www.linkedin.com/company/coara" target="_blank">https://www.linkedin.com/company/coara</a>
        </li>
        <li class="section__list__item"><strong>Headquarters:</strong> Tallinn, Estonia</li>
        <li class="section__list__item"><strong>Development Offices:</strong> Palma de Mallorca, Spain</li>
      </ul>
    </section>
  </div>

  <!-- Closing Banner -->
  <section class="sentence">
    <div class="sentence__wrapper">
      <p class="sentence__text">
        "Nearshoring with Coara means: Your team, our blueprint, zero risk."
        <span class="signature">Christian Bolz, CEO & Founder</span>
      </p>
    </div>
  </section>
</div>
